import React from 'react';

type Props = {};
export const Footer: React.FC<Props> = () => {
  return(
    <footer className="footer">
      <h2>Kyozai</h2>
      <p>&copy; 2020 Ren Matsushita & yusuke & miyazaki</p>
    </footer>
  )
}
